export const placeKey = 'county_list'
export const tenureKey = 'tenure'
export const costBurdenKey = 'cost_burden_threshold'
export const costBurdenBinKey = 'cost_burden_grouping'
export const valueKey = 'households'
export const amiMethodKey = 'percent_ami_category'
export const amiBinKey = 'ami_grouping'

export const tenureTypes = ['Renter', 'Owner', 'All Households']
export const costBurdenThresholds = [
  { value: '30', label: '30% of income' },
  { value: '40', label: '40% of income' },
  { value: '50', label: '50% of income' }
]

export const amiMethods = [
  {
    value: '0-50% AMI, 50.01-80% AMI, Over 80% AMI',
    label: '0-50% AMI, 50.01-80% AMI, Over 80% AMI'
  },
  {
    value: '0-60% AMI, 60.01-100% AMI, Over 100% AMI',
    label: '0-60% AMI, 60.01-100% AMI, Over 100% AMI'
  }
]

export const amiBinSortOrder = {
  '0-50% AMI': 0,
  '50.01-80% AMI': 1,
  'Over 80% AMI': 2,
  '0-60% AMI': 0,
  '60.01-100% AMI': 1,
  'Over 100% AMI': 2
}

export const defaultAmiMethod = amiMethods[0].value
export const defaultPlace = 'Alachua County'
export const defaultTenure = 'Owner'
export const defaultCostBurdenThreshold = '30'

export const baliHaiTeal = '#8497B0'
export const oxfordBlue = '#333F4F'

export const xOffset = 35

export const colorHash = {
  below: baliHaiTeal,
  above: oxfordBlue
}

export const sourceText = `Shimberg Center analysis of U.S. Census Bureau,
  2019 American Community Survey 1-Year Public Use Microdata Sample (PUMS). Student-headed, non-family households are excluded.`

export const tooltipColorKeyLabels = {
  below: 'non-cost burdened',
  above: 'cost burdened'
}
